import usePageTitle from "../utils/usePageTitle";
import React, { useEffect, useState } from "react";
import { Container } from "common-tailwind-components";
import { useTranslation } from "react-i18next";

import { get_recording_feed_ws_url } from "../api";
import type { StatusPayload } from "../api/types";
import useRecordingControls from "../utils/useRecordingControls";
import useScrollToTop from "../utils/useScrollToTop";
import { frontendCapabilities } from "../globals";

const RecordingSession = () => {
  const { t } = useTranslation();
  usePageTitle(t("recording_session"));
  const { applyRecordingStatus } = useRecordingControls();
  const [feedItems, setFeedItems] = useState<string[]>([]);
  useScrollToTop("recording-session");

  useEffect(() => {
    if (!frontendCapabilities.localRecording) {
      return;
    }

    const ws = new WebSocket(get_recording_feed_ws_url());
    ws.onmessage = ev => {
      try {
        const payload = JSON.parse(ev.data);
        if (payload.type === "feed_item" && payload.item) {
          setFeedItems(prev => [...prev, payload.item as string]);
        } else if (payload.type === "status" && payload.data) {
          const data = payload.data as StatusPayload;
          if (data.ok) {
            applyRecordingStatus(data);
          }
        }
      } catch (_) {}
    };
    return () => ws.close();
  }, [applyRecordingStatus]);

  if (!frontendCapabilities.localRecording) {
    return (
      <Container>
        <div className="px-6 pb-16 pt-7">
          <div className="rounded-2xl border border-outline bg-surface p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-text">{t("recording_session")}</h2>
            <p className="mt-1 text-sm text-text-dim">{t("local_recording_unavailable")}</p>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="px-6 pb-16 pt-7">
        <div className="rounded-2xl border border-outline bg-surface p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-text">{t("activity_feed")}</h2>
          <p className="mt-1 text-sm text-text-dim">
            {t("live_activity_captured_during_recording")}
          </p>
          <div className="mt-4 max-h-[60vh] space-y-2 overflow-auto rounded-xl border border-outline bg-surface-strong p-3">
            {feedItems.length === 0 && (
              <p className="text-sm text-text-dim">{t("no_feed_events_yet")}</p>
            )}
            {feedItems.map((item, index) => (
              <div
                key={`${item}-${index}`}
                className="rounded-lg border border-outline bg-surface px-3 py-2 text-sm text-text"
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default RecordingSession;
